const YoutubeVideoProvider = `
  fragment YoutubeVideoProvider on YoutubeVideoProvider {
    providerType
    videoDuration
    videoId
  }
`
export default YoutubeVideoProvider
